import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { FormControl, FormHelperText, InputLabel, Select } from '@mui/material';

export default function FormSelect({ name, children, disabled, label, size }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, onBlur, value, ref },
        fieldState: { error },
      }) => (
        <FormControl size={size} fullWidth variant="outlined">
          <InputLabel
            variant="outlined"
            size={size}
            id={`${name}-simple-select-standard-label`}
          >
            {label}
          </InputLabel>
          <Select
            variant="outlined"
            labelId={`${name}-simple-select-standard-label`}
            id={`${name}-simple-select-standard`}
            disabled={disabled}
            name={name}
            onChange={onChange}
            value={value || ''}
            onBlur={onBlur}
            inputRef={ref}
            error={!!error}
            size={size}
            label={label}
          >
            {children}
          </Select>
          {!!error && (
            <FormHelperText error={!!error}>{error?.message}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}

FormSelect.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string,
  disabled: PropTypes.bool,
};

FormSelect.defaultProps = {
  disabled: false,
};
